import { applyToCreditCard } from "./apply_to_credit_card";
import { tableTotalAvg } from "../../../objects/CommonUse/table_total_avg";
import assetExpLoanShortnameDataset from "../../../datasets/asset_exp_loan__shortname_dataset";


export const applyMonthlyMiscExpToCreditCard = (expenseTable, creditCardInfo, nbrMonths, spendHistCredit) => {
           
     // calculate average credit card unplanned amounts accrued for all prior periods...  this will be used
     // to determine the amount accrued for a month when period is more than 1 month long.
     let averageTurnAmt = 0;
     //  if only 1 month in the period then do not need to calculate or use an estimated unplanned amount.
     if (nbrMonths > 1){ 
          const totalAvgObj = tableTotalAvg(spendHistCredit, false, true);
          //  amounts are stored as negative so have to multiply by -1
          averageTurnAmt = totalAvgObj.averageAmt * -1;
          if (averageTurnAmt !== 0){
               // the estUnplannedAmt is an estimated amount per month.  Actuals have already been posted
               // for current month 
               const estUnplannedAmt = (averageTurnAmt * (nbrMonths - 1)).toFixed(2);
               creditCardInfo = applyToCreditCard(creditCardInfo, estUnplannedAmt,  
                    "Non-budgeted (unplanned) Expenses", "Misc Expenses", "estimatedUnplanned");
          }
     }
   
     for (let i=0; i<expenseTable.length; i++){
          if (expenseTable[i].chargeCreditCard  &&
              expenseTable[i].chargeCreditCard === true ){
               let expAmount = expenseTable[i].expAmount * nbrMonths;
               let creditCategory = expenseTable[i].expItem;
               const expInfoObj = assetExpLoanShortnameDataset.find(elem => elem.fullName === creditCategory);
               if (expInfoObj && expInfoObj.chargeCategory){
                    creditCategory = expInfoObj.chargeCategory;
               }
               creditCardInfo = applyToCreditCard(creditCardInfo, expAmount, expenseTable[i].expDesc,
                    expenseTable[i].expItem, "planned");
          }
     }  

     return creditCardInfo;
   
}

